import StartEventHook from './StartEventHook'
import 'smrtb-pbjs/modules/consentManagement'
import Logger from '../Log'

const Log = Logger.for('GdprHook')

export default class GdprStartHook extends StartEventHook {
  constructor () {
    super('GdprHook')
  }

  run (remoteConfig) {
    const opts = remoteConfig.prebidOpts()

    return new Promise((resolve, reject) => {
      if (window.__cmp) {
        let timedOut = false

        const to = setTimeout(() => {
          Log.warn('Publishers CMP never responded to data request! What heck')
          timedOut = true
          resolve()
        }, 500)

        window.__cmp('getConsentData', null, d => {
          if (timedOut) {
            Log.warn('Dang, CMP was slow to respond so we marked it as not present. Better luck next time')
            return
          }

          Log.info('Good news, CMP is alive and kicking. Registering gdpr pbjs config')
          clearTimeout(to)

          opts.consentManagement = {
            gdpr: {
              timeout: 2000,
              cmpApi: 'iab',
              defaultGdprScope: true,
              allowAuctionWithoutConsent: true
            }
          }

          resolve()
        })
      } else {
        Log.info('No CMP present, skipping gdpr config')
        resolve()
      }
    })
  }
}
